import { Component, OnInit, OnChanges, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'ep-tracking-status',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './tracking-status-label.component.html'
})

export class TrackingStatusLabelComponent implements OnInit, OnChanges {

    constructor() { }

    @Input() currentStatus: string;

    currentCssClass: string;

    private knowStatuses = {
        "Failed": "label failed",
        "Completed": "label completed",
        "Processing": "label processing",
        "Ignored": "label ignored",
        "On Hold": "label onhold",
        "Awaiting Control": "label awaiting-control",
        "Outbox": "label outbox",
        "Inbox": "label inbox",
        "Ready for test": "label ready-for-test",
        "Batching": "label batching",
        "AwaitingConfirmation": "label awaitingconfirmation"
    };

    ngOnInit(): void {
        this.setCssClass();
    }

    ngOnChanges(changes: any) {
        if (changes.currentStatus) {
            this.setCssClass();
        }
    }

    private setCssClass() {
        var knownCssClass = this.knowStatuses[this.currentStatus];
        if (knownCssClass) {
            this.currentCssClass = knownCssClass;
        }
        else {
            this.currentCssClass = "label status-fallback";
        }
    }
}
